var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRailApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Rail_App",
    "data-name": "icon Rail App",
    transform: "translate(-1287 -331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1992",
    "data-name": "Rectangle 1992",
    className: "cls-1",
    width: 24,
    height: 24,
    transform: "translate(1287 331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M.8,12.4H3l-.307.74A1.2,1.2,0,0,0,3.8,14.8H5.128a1.2,1.2,0,0,0,1.157-.88l.42-1.52H17.3l.42,1.52a1.2,1.2,0,0,0,1.157.88H20.2a1.2,1.2,0,0,0,1.109-1.66L21,12.4h2.2a.8.8,0,0,0,.694-1.2l-1.146-2a.8.8,0,0,0-.7-.4H19.506l-.5-1.2h1.44a.8.8,0,0,0,.694-1.2l-.686-1.2a.8.8,0,0,0-.694-.4H17.846L17.514,4h.875a.8.8,0,0,0,.694-1.2L18.625,2a.8.8,0,0,0-.694-.4H16.517L16.058.493A.8.8,0,0,0,15.317,0h-.4a.8.8,0,0,0-.77,1.014l.162.586H9.693l.162-.585A.8.8,0,0,0,9.085,0h-.4a.8.8,0,0,0-.742.495L7.485,1.6H6.071a.8.8,0,0,0-.695.4l-.458.8A.8.8,0,0,0,5.613,4h.875l-.332.8H4.241a.8.8,0,0,0-.7.4L2.859,6.4a.8.8,0,0,0,.694,1.2h1.44l-.5,1.2H1.947a.8.8,0,0,0-.694.4l-1.146,2A.8.8,0,0,0,.8,12.4Zm6.125-.8.555-2h9.04l.553,2ZM9.029,4h5.944l.221.8H8.807ZM8.586,5.6h6.83l.332,1.2H8.254Zm-.553,2h7.936L16.3,8.8H7.7Zm14.022,2,1.146,2H20.668l-.83-2Zm-2.294-4,.687,1.2H18.676l-.5-1.2ZM17.93,2.4l.458.8H17.181l-.332-.8ZM15.321.8l5.247,12.647A.4.4,0,0,1,20.2,14H18.874a.4.4,0,0,1-.386-.293L14.917.8Zm-.789,1.6.221.8H9.25l.221-.8ZM8.685.8l.4,0v0L5.514,13.707A.4.4,0,0,1,5.128,14H3.8a.4.4,0,0,1-.37-.554ZM5.613,3.2l.458-.8h1.08l-.332.8ZM3.553,6.8l.688-1.2H5.826l-.5,1.2ZM1.947,9.6H4.164l-.83,2H.8Z",
    transform: "translate(1286.998 336)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailApp);
export default __webpack_public_path__ + "static/media/rail-app.9b4f6141628d0aef6ee003ebff098a95.svg";
export { ForwardRef as ReactComponent };